document.addEventListener('DOMContentLoaded', function () {
  /*
   * Each rule contributes its qualifying scanner quantity toward
   * the listed bonus variants.
   *
   * Because several scanner families use the same bonus product,
   * desired quantities are totaled before the cart is modified.
   */
  const AUTO_BUNDLES = [
    {
      name: "EinScan Rigil Series",
      triggerVariantIds: [
        46889696886953, // EinScan Rigil
        46979377889449, // EinScan Rigil Lite Limited Edition
        46979377922217  // EinScan Rigil Lite Regular Version
      ],
      bonusVariantIds: [
        47269719015593, // Accessories Pro Kit
        47269424693417  // 1-Year License of EXModel Personal
      ]
    },
    {
      name: "FreeScan Combo Series",
      triggerVariantIds: [
        45425558519977, // FreeScan Combo
        45425558552745  // FreeScan Combo+
      ],
      bonusVariantIds: [
        47269719015593, // Accessories Pro Kit
        47269424693417  // 1-Year License of EXModel Personal
      ]
    },
    {
      name: "EinScan Medixa",
      triggerVariantIds: [
        46623957942441 // EinScan Medixa
      ],
      bonusVariantIds: [
        47269424693417 // 1-Year License of EXModel Personal
      ]
    },
    {
      name: "EinScan Libre",
      triggerVariantIds: [
        45454201979049 // EinScan Libre
      ],
      bonusVariantIds: [
        47269719015593, // Accessories Pro Kit
        47269424693417  // 1-Year License of EXModel Personal
      ]
    },
    {
      name: "EinStar Rockit",
      triggerVariantIds: [
        47171526885545, // EinStar Rockit + Accessories Pro Kit 
      ],
      bonusVariantIds: [
        47269719015593, // Accessories Pro Kit 3d scanner bundle only
      ]
    },
    {
      name: "EinStar Rockit 2",
      triggerVariantIds: [
        47171526918313 // EinStar Rockit + ExModel Personal
      ],
      bonusVariantIds: [
        47269424693417  // 1-Year License of EXModel Personal
      ]
    },
    {
      name: "EinStar 2",
      triggerVariantIds: [
        47171527901353 // EinStar 2 + ExModel Personal
      ],
      bonusVariantIds: [
        47269424693417  // 1-Year License of EXModel Personal
      ]
    },
    {
      name: "EinStar 2",
      triggerVariantIds: [
        47171527868585 // EinStar 2 + Accessories Pro Kit
      ],
      bonusVariantIds: [
        47269719015593  // Accessories Pro Kit
      ]
    }                    
  ];

  /*
   * Use one permanent property set for each shared bonus variant.
   * Do not change these properties based on which scanner triggered it.
   */
  const BONUS_PRODUCTS = {
    47269719015593: {
      id: 47269719015593,
      properties: {
        "_bundle_gift": "true",
        "_bundle_bonus_id": "accessories-pro-kit",
        "Gift": "Accessories Pro Kit with eligible scanner"
      }
    },
    47269424693417: {
      id: 47269424693417,
      properties: {
        "_bundle_gift": "true",
        "_bundle_bonus_id": "exmodel-personal-one-year",
        "Gift": "1-Year License of EXModel Personal"
      }
    }
  };

  let isSyncing = false;
  let syncTimer = null;

  function cartUrl(endpoint) {
    const root =
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    return `${root}${endpoint}`;
  }

  async function getCart() {
    const response = await fetch(cartUrl('cart.js'), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error(`Unable to retrieve cart: ${response.status}`);
    }

    return response.json();
  }

  async function addItem(item) {
    const response = await fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(item.id),
            quantity: Number(item.quantity),
            properties: item.properties
          }
        ]
      })
    });

    if (!response.ok) {
      const message = await response.text();
      throw new Error(
        `Unable to add bundle item: ${response.status} ${message}`
      );
    }

    return response.json();
  }

  async function changeLineItem(lineKey, quantity) {
    const response = await fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: Number(quantity)
      })
    });

    if (!response.ok) {
      const message = await response.text();
      throw new Error(
        `Unable to change bundle item: ${response.status} ${message}`
      );
    }

    return response.json();
  }

  function getTriggerQuantity(cart, triggerVariantIds) {
    const triggerIds = new Set(
      triggerVariantIds.map(id => Number(id))
    );

    return cart.items.reduce((total, item) => {
      if (triggerIds.has(Number(item.variant_id))) {
        return total + Number(item.quantity);
      }

      return total;
    }, 0);
  }

  /*
   * Calculate the final quantity required for each bonus before
   * making any cart changes.
   *
   * Example:
   * 1 Rigil + 1 Libre =
   * 2 Accessories Pro Kits
   * 2 EXModel Personal licenses
   */
  function calculateDesiredBonusQuantities(cart) {
    const desiredQuantities = new Map();

    for (const bundle of AUTO_BUNDLES) {
      const triggerQuantity = getTriggerQuantity(
        cart,
        bundle.triggerVariantIds
      );

      if (triggerQuantity <= 0) {
        continue;
      }

      for (const bonusVariantId of bundle.bonusVariantIds) {
        const bonusId = Number(bonusVariantId);
        const currentDesired = desiredQuantities.get(bonusId) || 0;

        desiredQuantities.set(
          bonusId,
          currentDesired + triggerQuantity
        );
      }
    }

    return desiredQuantities;
  }

  function isManagedGiftLine(item, bonusProduct) {
    return (
      Number(item.variant_id) === Number(bonusProduct.id) &&
      item.properties &&
      String(item.properties._bundle_gift) === 'true' &&
      String(item.properties._bundle_bonus_id) ===
        String(bonusProduct.properties._bundle_bonus_id)
    );
  }

  function getManagedGiftLines(cart, bonusProduct) {
    return cart.items.filter(item =>
      isManagedGiftLine(item, bonusProduct)
    );
  }

  function getUnmanagedBonusLines(cart, bonusProduct) {
    return cart.items.filter(item =>
      Number(item.variant_id) === Number(bonusProduct.id) &&
      !isManagedGiftLine(item, bonusProduct)
    );
  }

  async function synchronizeBonusProduct(
    bonusProduct,
    desiredQuantity
  ) {
    let cart = await getCart();

    /*
     * These variants are assumed to be dedicated bundle-only products.
     * Remove legacy, paid, or incorrectly tagged copies.
     */
    let unmanagedLines = getUnmanagedBonusLines(
      cart,
      bonusProduct
    );

    for (const line of unmanagedLines) {
      await changeLineItem(line.key, 0);
      cart = await getCart();
    }

    /*
     * Remove duplicate managed lines, retaining one line only.
     */
    let managedLines = getManagedGiftLines(
      cart,
      bonusProduct
    );

    if (managedLines.length > 1) {
      for (const duplicateLine of managedLines.slice(1)) {
        await changeLineItem(duplicateLine.key, 0);
        cart = await getCart();
      }
    }

    managedLines = getManagedGiftLines(
      cart,
      bonusProduct
    );

    const managedLine = managedLines[0];

    /*
     * No qualifying scanner remains.
     */
    if (desiredQuantity <= 0) {
      if (managedLine) {
        await changeLineItem(managedLine.key, 0);
        return true;
      }

      return unmanagedLines.length > 0;
    }

    /*
     * Add the managed gift only when it does not already exist.
     */
    if (!managedLine) {
      await addItem({
        id: bonusProduct.id,
        quantity: desiredQuantity,
        properties: bonusProduct.properties
      });

      return true;
    }

    /*
     * Update the existing line using its unique line-item key.
     */
    if (Number(managedLine.quantity) !== Number(desiredQuantity)) {
      await changeLineItem(
        managedLine.key,
        desiredQuantity
      );

      return true;
    }

    return unmanagedLines.length > 0;
  }

  async function syncBundles() {
    if (isSyncing) {
      return;
    }

    isSyncing = true;
    let cartChanged = false;

    try {
      const cart = await getCart();
      const desiredQuantities =
        calculateDesiredBonusQuantities(cart);

      /*
       * Each shared bonus product is synchronized exactly once.
       */
      for (const bonusProduct of Object.values(BONUS_PRODUCTS)) {
        const desiredQuantity =
          desiredQuantities.get(Number(bonusProduct.id)) || 0;

        const changed = await synchronizeBonusProduct(
          bonusProduct,
          desiredQuantity
        );

        if (changed) {
          cartChanged = true;
        }
      }

      if (cartChanged) {
        /*
         * Reload only after the final desired state has been applied.
         */
        window.setTimeout(function () {
          window.location.reload();
        }, 400);
      }
    } catch (error) {
      console.error('[Auto Bundles]', error);
    } finally {
      isSyncing = false;
    }
  }

  function scheduleBundleSync(delay = 1200) {
    window.clearTimeout(syncTimer);

    syncTimer = window.setTimeout(function () {
      syncBundles();
    }, delay);
  }

  // Initial cart check.
  syncBundles();

  // Quantity field changes.
  document.addEventListener('change', function (event) {
    if (
      event.target.matches('input[name="updates[]"]') ||
      event.target.matches('input.quantity__input') ||
      event.target.closest('quantity-input')
    ) {
      scheduleBundleSync();
    }
  });

  // Quantity and remove-button clicks.
  document.addEventListener('click', function (event) {
    if (
      event.target.closest('.quantity__button') ||
      event.target.closest('cart-remove-button') ||
      event.target.closest('a[href*="/cart/change"]') ||
      event.target.closest('button[name="plus"]') ||
      event.target.closest('button[name="minus"]')
    ) {
      scheduleBundleSync();
    }
  });

  /*
   * Watch only the cart area. Do not fall back to document.body,
   * because unrelated page changes can repeatedly schedule syncs.
   */
  const cartContainer =
    document.querySelector('cart-items') ||
    document.querySelector('cart-drawer-items') ||
    document.querySelector('form[action*="/cart"]');

  if (cartContainer) {
    const observer = new MutationObserver(function () {
      scheduleBundleSync(1500);
    });

    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      scheduleBundleSync();
    }
  });
});